import { Box, Divider, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";

const CatatanComponent = ({ add_func }) => {
  const [note, setNote] = useState("");

  const handleChange = (e) => {
    setNote(e.target.value);
  };

  useEffect(() => {
    localStorage.setItem("note_data", note);
    add_func?.(true);
  }, [note]);

  return (
    <>
      <Divider />
      <Typography
        fontSize="1em"
        fontWeight={700}
        textTransform="capitalize"
        my={1}
      >
        Catatan
        <Typography variant="subtitle2">
          Opsional — tulis permintaan khusus
        </Typography>
      </Typography>

      <Box
        width="100%"
        display="flex"
        flexDirection="column"
        gap={1}
        my={1}
      >
        <TextField
          fullWidth
          multiline
          minRows={2}
          maxRows={4}          
          value={note}
          onChange={handleChange}
        />
      </Box>
    </>
  );
};

export default CatatanComponent;